import { render, staticRenderFns } from "./PartnerDeliveryTimeSetting.vue?vue&type=template&id=9fc4e12a&scoped=true"
import script from "./PartnerDeliveryTimeSetting.vue?vue&type=script&lang=js"
export * from "./PartnerDeliveryTimeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc4e12a",
  null
  
)

export default component.exports